exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media (min-width: 1024px){.mobile-only[data-v-828c87b8]{display:none !important}}@media (max-width: 1023px){.desktop-only[data-v-828c87b8]{display:none !important}}@media (min-width: 1024px){.o-footer[data-v-828c87b8]{margin:auto}}.o-footer .sf-footer[data-v-828c87b8]{--footer-width: auto}\n", ""]);

// exports
